import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as S from './UserPasswordUI.styles';
import * as C from '../Common.styles';

import Eye from './EyeIcon';
import {getTerms} from '../../../../store/actions/thunk';

import {validations} from '../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';

import IconSelector from '@ibibo/icon-selector';
import ButtonLoader from '../../UI/Loader/Loader';
import PopUp from '../../UI/Popup/Popup';
import {tokenSelector, agencyNameSelector, fullnameSelector, addressSelector, gstNumberSelector, panNumberSelector, emailSelector, mobileSelector, verify_mmt_passwordSelector, account_existsSelector, account_existsMessageSelector} from '../../../../store/selectors';

const UserPasswordUI = ({setPassword, mobileUser, setLoader, apiError, onforgotPwdClickHandler, tokenApiMessage, forgotPasswordLoader}) => {

  const dispatch = useDispatch();

  const [{user_name, password, confirm_pass}, setUserPass] = useState({
    user_name: mobileUser,
    password: '',
    confirm_pass: ''
  });

  const [userAgree, setUserAgree] = useState('');
  const [userConsent, setUserConsent] = useState('');


  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [popVisible, setpopVisible] = useState(false);
  const [userAgreed, setUserAgreed] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const token = useSelector(tokenSelector);
  const agency_name = useSelector(agencyNameSelector);
  const agent_name = useSelector(fullnameSelector);
  const address = useSelector(addressSelector);
  const gstin = useSelector(gstNumberSelector);
  const pan_details = useSelector(panNumberSelector);
  const email = useSelector(emailSelector);
  const mobile = useSelector(mobileSelector);
  const account_exists = useSelector(account_existsSelector);
  const verify_mmt_password = useSelector(verify_mmt_passwordSelector);
  const account_existsMessage = useSelector(account_existsMessageSelector);


  const [{confirmErrors, errorCheck} ,  setconfirmErrors] = useState({
    confirmErrors: '',
    errorCheck: false
  });

  const successCallback = (data) => {
    setUserAgree(data);
  }
  
  const errorCallback = () => {
  }

  const dataTerms = {
    token,
    agency_name,
    agent_name,
    address,
    gstin,
    pan_details,
    email,
    mobile
  }

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setUserPass({
      user_name: mobileUser,
      password,
      confirm_pass
    })
  }, [mobileUser]);

  useEffect(() => {
    if (mobileUser && !userAgreed) {
      let fd = new FormData();
      for (const key in dataTerms) {
        fd.append(key, dataTerms[key]);
      }
      dispatch(getTerms(fd, successCallback, errorCallback));
    }
  }, [mobileUser]);

  const minPwdLen = 8;

  const onChangeHandler = (field, value) => {
    const data = {
      user_name,
      password,
      confirm_pass
    };
    data[field] = value;
    setUserPass(data);
    if (field === 'password') {
      onKeyPress(data[field]);
    }
  }

  const fieldValidators = {
    'user_name': {'field': 'user_name', 'fieldName': 'User name', 'validators': ['required']},
    'password': {'field': 'password', 'fieldName': 'Password', 'validators': ['required', 'password']},
    'confirm_pass': {'field': 'confirm_pass', 'fieldName': 'Confirm Password', 'validators': ['required', 'sameFieldValue']},
    'tncChecked': {'field': 'password', 'fieldName': 'terms and conditions', 'validators': ['mustRead']}
  };

  const validateField = (field, dataObj) => {
    const errorObj = {...errors};
    if (fieldValidators[field]) {
      errorObj[field] = '';
      const validators = fieldValidators[field].validators;
      for (let i = 0; i < validators.length; i++) {
        const validateFunction = validations[validators[i]];
        const validateDataObj = {
          value: dataObj[field],
          fieldName: fieldValidators[field].fieldName,
          length: minPwdLen
        };
        if (field === 'confirm_pass') {
          validateDataObj.valueToMatch = password;
          validateDataObj.fieldToMatch = 'password';
        }
        const resp = validateFunction(validateDataObj);
        if (resp && !errorObj[field]) {
          errorObj[field] = resp;
        }
      }
    }
    setError(errorObj);
  };

  const validateFields = (data) => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const validateDataObj = {
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            length: minPwdLen
          };
          if (key === 'confirm_pass') {
            validateDataObj.valueToMatch = password;
            validateDataObj.fieldToMatch = 'password';
          }
          const resp = validateFunction(validateDataObj);
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  }

  const setUserNamePass = (event: React.FormEvent) => {
    sendEvarData({
      prop54: "myPatner|signup|setPassword|getStarted"
    }, true)
    event.preventDefault();
      const data = {
        user_name,
        ...((!account_exists || (account_exists && verify_mmt_password)) && {password: password} ),
        // password,
        // confirm_pass,
        ...(!account_exists && {confirm_pass: confirm_pass} ),
        tncChecked: userAgreed,
        userConsent
      };
      const hasError = validateFields(data);
      if (!hasError) {
        if(!account_exists) {
          if(password === confirm_pass){
            setPassword(data);
            setconfirmErrors({confirmErrors: '', errorCheck: false});
          }else{
            setconfirmErrors({confirmErrors: 'Passwords are not matching', errorCheck: true});
          }
        } else {
          setPassword(data);
        }
      }
  };

  const onKeyPress = (val) => {
    validateField('password', {password: val});
  }

  const onBlur = (field, val) => {
    validateField(field, {confirm_pass: val});
  }

  const showPopup = () => {
    sendEvarData({
      prop54: "myPatner|signup|setPassword|docPreview|agreement"
    }, true)
    setpopVisible(true);
  }

  const cancelEvent = () => {
    sendEvarData({
      prop54: `myPatner|signup|setPassword|tnc|${userAgreed ? "checked" : "unchecked"}`
    }, true)
    setpopVisible(false);
    setUserAgreed(userAgreed);
  }

  const agreeEvent = () => {
    sendEvarData({
      prop54: "myPatner|signup|setPassword|tnc|checked"
    }, true)
    setpopVisible(false);
    setUserAgreed(true);
    let newDate = (new Date).getTime();
    setUserConsent(newDate);
  }

  const getPasswordInput = () => {
    if (!account_exists || (account_exists && verify_mmt_password)) {
      return (
        <C.InputWrapper>
          <C.CommonInputWrap>
            <C.CommonInput
              type={!showPassword ? 'password' : 'text'}
              placeholder="Password"
              name="password"
              value={password}
              onChange={event => {
                onChangeHandler('password', event.target.value);
              }}
              hasError={errors['password'] ? true : false}
            ></C.CommonInput>
            <C.ErrorText>{errors['password']}</C.ErrorText>
            <S.EyeWrapper>
              <Eye
                showPassword={showPassword}
                setShowPassword={() => setShowPassword(!showPassword)}
              />
            </S.EyeWrapper>
            {
              account_exists && verify_mmt_password ? (
              forgotPasswordLoader ? (
                <S.ForgotPasswordLoaderContainer>
                  <ButtonLoader loaderType="gstin"/>
                </S.ForgotPasswordLoaderContainer>
              ) : (
                <S.ForgotPasswordBlock> 
                  <S.ForgotPasswordBlockText onClick={onforgotPwdClickHandler}> 
                    Forgot Password? 
                  </S.ForgotPasswordBlockText> 
                </S.ForgotPasswordBlock> 
              )
              ) : null
            }
            {(errors['password'] && (
              <S.StrongFailInfo>
                <S.WeakText>Weak</S.WeakText>
              </S.StrongFailInfo>
            )) ||
              null}
            {(!errors['password'] && password !== '' && (
              <S.StrongPassInfo>
                <S.StongText>Strong</S.StongText>
              </S.StrongPassInfo>
            )) ||
              null}
          </C.CommonInputWrap>
        </C.InputWrapper>
      );
    }
    return null;
  };

  const getConfirmPasswodInput = () => {
    if(!account_exists) {
      return (
        <C.InputWrapper>
          <C.CommonInputWrap>
            <C.CommonInput
              type="password"
              placeholder="Confirm password"
              name="confirmPass"
              value={confirm_pass}
              onChange={event => onChangeHandler('confirm_pass', event.target.value)}
              onBlur={event => onBlur('confirm_pass', event.target.value)}
              hasError={errorCheck ? true : false}
            ></C.CommonInput>
            {(!errors['confirm_pass'] && confirm_pass !== '' && confirm_pass === password && (
              <S.TickIconWrapper>
                <IconSelector iconKey="tickmarkwhite" props={{width: '1rem', height: '1rem'}} />
              </S.TickIconWrapper>
            )) ||
              null}
            <C.ErrorText>{errors['confirm_pass']}</C.ErrorText>
            {confirmErrors.length > 0 && <C.ErrorText>{confirmErrors}</C.ErrorText>}
          </C.CommonInputWrap>
        </C.InputWrapper>
      );
    }
    return null;
  };

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>You’re all set!</C.WelcomeHeadText>

      {/* <C.HeadSubText>
        Set a password of choice and you’re done. And don’t worry - you can change this later too!
      </C.HeadSubText> */}
      {account_existsMessage ? (
        <C.HeadSubTitleText>
          <C.HeadSubTitleTextSpan>
          {account_existsMessage}
          </C.HeadSubTitleTextSpan>
        </C.HeadSubTitleText>
      ) : null}
      <C.FormWrapper>
        <C.UserInfoForm onSubmit={setUserNamePass}>
          <C.InputWrapper>
            <C.CommonInputWrap>
              <C.CommonInput
                type="text"
                name="userName"
                value={mobileUser}
                disabled
              ></C.CommonInput>
              <C.ErrorText>{errors['user_name']}</C.ErrorText>
              <S.StrongPassInfo>
                <S.StongText>Username</S.StongText>
              </S.StrongPassInfo>
            </C.CommonInputWrap>
          </C.InputWrapper>

          {getPasswordInput()}
          {getConfirmPasswodInput()}
          {
            !account_exists ? (
              <S.StronInfoWrapper>
                <S.StrongHeadText>Set a strong password:</S.StrongHeadText>
                {/* <S.StrongSubText>Minimum 6 characters, at least one number and no spaces</S.StrongSubText> */}
                <S.StrongSubText>
                  Minimum 8 characters, with a mix of letters, numbers & symbols @$!%#?&
                </S.StrongSubText>
              </S.StronInfoWrapper>
            ) : null
          }
          <S.UserImportantInfoWrap>
            <S.UserConsentText HTMLfor="terms" onClick={showPopup}>
              <S.UserTermsCheck id="terms" checked={userAgreed}></S.UserTermsCheck>
              <span>
                I agree to all the <S.UserTermsText>Terms & Conditions</S.UserTermsText>
              </span>
            </S.UserConsentText>
            <C.ErrorText>{errors['tncChecked']}</C.ErrorText>
          </S.UserImportantInfoWrap>

          <C.ApiErrorText>
            {apiErrorMsg && apiErrorMsg.screen === 'update' ? apiErrorMsg.msg : ''}
          </C.ApiErrorText>
          <C.ApiErrorText>
            {tokenApiMessage}
          </C.ApiErrorText>
          <C.ButtonWrapper>
            <C.SignUpBtn type="submit">
              {setLoader ? <ButtonLoader loaderType="button" /> : 'Get started'}
            </C.SignUpBtn>
          </C.ButtonWrapper>
        </C.UserInfoForm>
      </C.FormWrapper>

      {popVisible ? (
        <div>
          <C.PopOverlay />
          <PopUp cancelEvent={cancelEvent} agreeEvent={agreeEvent} termsMarkup={userAgree} policy={false}/>{' '}
        </div>
      ) : null}
    </C.FormMainWrapper>
  );
};

export default UserPasswordUI;

